export const MEDIA_INTERRUPTION_GRACE_MS = 1400;
export const MEDIA_RESUME_DELAY_MS = 250;

export const isMediaTrackHealthy = (track, publicationMuted = false) => Boolean(
  track
  && track.readyState === "live"
  && track.muted !== true
  && publicationMuted !== true
);

export const getMediaRecoveryDelay = (reason) => (
  reason === "mute" ? MEDIA_INTERRUPTION_GRACE_MS : MEDIA_RESUME_DELAY_MS
);
